import { ToastOptions } from 'react-toastify';

import { showToast } from "../components/messages-and-errors/ToastsNotifications";

type HandlerValue = {
  message: string
  toastType: string
  toastId: string
}

type Action = {
  type: string
  payload: any
}

type Handler = {
  [actionName: string]: (action: Action) => HandlerValue
}

export const handleToastByActionType = (handlers: Handler, toastConfigs: ToastOptions = {}): (action: Action) => void => {
  return action => {
    const getToastInformation = handlers[action.type];
    if(!getToastInformation) return;

    const toastInformation = getToastInformation(action);

    showToast(
      toastInformation.message,
      toastInformation.toastType,
      { autoClose: 60000, toastId: toastInformation.toastId, height: 300, ...toastConfigs },
    );
  }
}